<template>
  <main>
    <h1>应天门活动查询</h1>
    <input type="text" v-model="phone" placeholder="请输入电话号码" required>
    <input type="text" v-model="code" placeholder="请输入验证码" required>
    <button class="btn" @click="onVerify">获取验证码</button>
    <button class="btn" @click="onSend">立 即 查 询</button>
  </main>
  <show-msg :msg="msg"/>
</template>

<script>
import { useRouter } from 'vue-router'
import { ref } from 'vue'
import axios from '@/use/useAxios'
import ShowMsg from '@/components/ShowMsg'
import showMsg, { msg } from '@/use/useShowMsg'

export default {
  name: 'Index',
  components: { ShowMsg },
  setup () {
    const router = useRouter()

    const phone = ref('')
    const code = ref('')
    const url = new URLSearchParams()
    const testPhone = phone => /^1[345678]\d{9}$/.test(phone)
    const testCode = code => /^\d{6}$/.test(code)

    const onVerify = _ => {
      url.delete('phone')
      url.append('phone', phone.value)

      testPhone(phone.value)
        ? axios.post('/active/verify', url, { 'Content-Type': 'application/x-www-form-urlencoded' })
          .then(d => {
            let message = d.data.data.split(',')
            if (message.length === 1) { message = d.data.data.split('，') }
            showMsg(message)
          })
        : showMsg('请输入正确的手机号')
    }

    const onSend = _ => {
      url.delete('phone')
      url.delete('code')

      url.append('phone', phone.value)
      url.append('code', code.value)

      testPhone(phone.value)
        ? testCode(code.value)
          ? axios.get('/active/activelist', {
            params: {
              phone: phone.value,
              code: code.value
            }
          }).then(d => d.data.code === 1000
            ? router.push(`/list/${phone.value}/${code.value}`)
            : showMsg(d.data.msg)
          )
          : showMsg('请输入正确的验证码')
        : showMsg('请输入正确的手机号')
    }

    return {
      phone,
      code,
      onVerify,
      onSend,
      msg
    }
  }
}
</script>

<style lang="scss" scoped>
main {
  display: grid;
  grid: 3fr repeat(3, 40px 1fr) 40px 3fr / 1fr 8fr 1fr;
  height: 100vh;
}
[type] {
  font-size: 20px;
  padding: 0 10px;
  background: rgba(0, 0, 0, 0);
  border: thin solid white { radius: 10px };
  color: white;
  outline: none;
  &:first-of-type { grid-area: 4 / 2 / 5 / 3 }
  &:last-of-type { grid-area: 6 / 2 / 7 / 3 }
  &::placeholder { color: rgba(255, 255, 255, .6); font-size: 16px }
}
.btn {
  &:first-of-type {
    grid-area: 6 / 2 / 7 / 3;
    justify-self: end;
    background: rgba(255, 255, 255, .3);
    color: white;
    outline: none;
    border: thin solid white { radius: 0 10px 10px 0 }
  }
  &:last-of-type {
    grid-area: 8 / 2 / 9 / 3;
    font-size: 20px;
    background: rgba(255, 255, 255, .3);
    color: white;
    outline: none;
    border: thin solid white { radius: 10px }
  }
}
h1 {
  font-size: 30px;
  text-align: center;
  color: white;
  grid-area: 2 / 2 / 3 / 3;
}
</style>
